import { render, staticRenderFns } from "./RankedChoice.vue?vue&type=template&id=82981822&scoped=true&"
import script from "./RankedChoice.vue?vue&type=script&lang=js&"
export * from "./RankedChoice.vue?vue&type=script&lang=js&"
import style0 from "./RankedChoice.vue?vue&type=style&index=0&id=82981822&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82981822",
  null
  
)

export default component.exports